export default __webpack_public_path__ + "static/media/waterFr.2e9e8a87.jpg";